import { Stack, Text } from '@mantine/core';

interface CandidatesEmptyListProps {
  Icon: React.ComponentType<{ size?: number; color?: string }>;
  label: string;
  description: string;
}

export default function CandidatesEmptyList({
  Icon,
  label,
  description,
}: CandidatesEmptyListProps) {
  return (
    <Stack align="center" flex={1}>
      <Icon size={40} color="var(--silver)" />
      <Text fz={20} fw={700} ta="center">
        {label}
      </Text>
      <Text ta="center">{description}</Text>
    </Stack>
  );
}
